function setCookie(cname, cvalue, exdays = 0) {
	var duration = exdays * 24 * 60 * 60;
	var maxAge = "max-age=" + duration + "; ";
	var path = "path=/; ";
	var cookie = cname + "=" + cvalue + "; ";
	var newCookie = cookie + path;

	if (exdays) {
		newCookie += maxAge
	}

	document.cookie = newCookie;
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export {
	getCookie,
	setCookie
};